import { _ } from '_core';

import { ReportSectionParams } from './types';

export const validate = (params: ReportSectionParams) => {
  if (_.isEmpty(params?.title)) return ['Title is a required field.'];
  return [];
};
